
import * as Data from '@/../src-gen/data';
import {PaymentStoreMutations} from '@/../src-gen/store/payment-store-support';
export const monthList = [{ "name": "Jan", "index": 0 }, { "name": "Feb", "index": 1 }, { "name": "Mar", "index": 2 }, { "name": "Apr", "index": 3 }, { "name": "May", "index": 4 }, { "name": "Jun", "index": 5 }, { "name": "Jul", "index": 6 }, { "name": "Aug", "index": 7 }, { "name": "Sept", "index": 8}, { "name": "Oct", "index": 9 }, { "name": "Nov", "index": 10 }, { "name": "Dec", "index": 11}];
export class PaymentStoreMutationsCode implements PaymentStoreMutations   {
  
  
   
   public updatePaymentPlanDetails(state: Data.Payment.PaymentStore, paymentPlanDetails: Data.Payment.PaymentPlanDetails): void {
     state.msfSlabList = paymentPlanDetails.msfSlabList;
     state.planDetails = paymentPlanDetails.planDetails;
     state.paymentPlanDetails = paymentPlanDetails;
   }
   
}

